<script>
  import { user } from "../../stores/User"
  import { BASE_URL } from "../../stores/BASE_URL"
  import SinInformacion from "../Sin_informacion.svelte"
  import Spinner from "../Spinner.svelte"
  import { navigate } from "svelte-routing"
  import getMoneda from "../../services/moneda.js"

  export let documento

  let data = {
    persona: undefined,
    loading: false,
  }

  let session_key = $user.session_key

  const settings = {
    sortable: true,
    pagination: true,
    rowsPerPage: 12,
    columnFilter: false,
    scrollY: false,
    blocks: {
      searchInput: false,
      paginationButtons: true,
      paginationRowCount: false,
    },
    labels: {
      previous: "Anterior",
      next: "Siguiente",
    },
  }

  let rows

  const cargarDatos = async () => {
    const ops = "laboral_acreditacion"
    data.loading = true
    const response = await fetch(
      `${BASE_URL}persona.php?documento=${documento}&session_key=${session_key}&ops=${ops}`,
    )
    const resp = await response.json()

    if (resp.status == "error") {
      navigate("/", { replace: true })
    }

    data = {
      persona: resp.data,
      loading: false,
    }
  }

  cargarDatos()
</script>

{#if data.loading === true}
  <Spinner />
{:else if data.persona.length === 0}
  <SinInformacion />
{:else if data.persona !== undefined}
  <div class="table-responsive">
    <table class="table table-striped table-sm">
      <thead>
        <th class="fg-secondary fw-normal">Devengue</th>
        <th class="fg-secondary fw-normal">Tipo afiliación</th>
        <th class="fg-secondary fw-normal">Tipo asegurado</th>
        <th class="fg-secondary fw-normal">Tipo seguro</th>
        <th class="fg-secondary fw-normal">Inicio vigencia</th>
        <th class="fg-secondary fw-normal">Fin vigencia</th>
        <th class="fg-secondary fw-normal text-end">Ingreso</th>
      </thead>
      <tbody>
        {#each data.persona as planilla}
          <tr>
            <td>{planilla.devengue}</td>
            <td>{planilla.tipoAfiliacion}</td>
            <td>{planilla.tipoAsegurado}</td>
            <td>{planilla.tipoSeguro}</td>
            <td>{planilla.inicioVigenciaAcreditacion}</td>
            <td>{planilla.finVigenciaAcreditacion}</td>
            <td class="text-end">
              {planilla.sueldo <= 0 ? "-" : getMoneda(planilla.sueldo)}
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
{/if}
